

































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import { VuePaycard } from 'vue-paycard';

@Component({
    components: {
        VuePaycard,
    },
})

export default class AddCreditCardOverlay extends Vue {
    public cardNumberMaxLength: number = 19;
    public minCardYear: any = new Date().getFullYear();
    public newCardData: any = {
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
    };

    constructor() {
        super();
    }

    get minCardMonth() {
        if (this.newCardData.cardYear === this.minCardYear) {
            return new Date().getMonth() + 1;
        }

        return 1;
    }

    public generateMonthValue(n: number) {
        return n < 10 ? `0${n}` : n;
    }

    public changeNumber(e: any) {
        this.newCardData.cardNumber = e.target.value;
        const value = this.newCardData.cardNumber.replace(/\D/g, '');

        // american express, 15 digits
        if ((/^3[47]\d{0,13}$/).test(value)) {
            this.newCardData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
            this.cardNumberMaxLength = 17;
        } else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
            this.newCardData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
            this.cardNumberMaxLength = 16;
        } else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
            this.newCardData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ');
            this.cardNumberMaxLength = 19;
        }

        if (e.inputType === 'deleteContentBackward') {
            const lastChar = this.newCardData.cardNumber.substring(this.newCardData.cardNumber.length, this.newCardData.cardNumber.length - 1);

            if (lastChar === ' ') {
                this.newCardData.cardNumber = this.newCardData.cardNumber.substring(0, this.newCardData.cardNumber.length - 1);
            }
        }
    }

    public flipCard(status: boolean) {
        const element = (this.$refs.creditCard as any);
        element.isCardFlipped = status;
    }

    public addNewCard() {
        this.$store.dispatch(Actions.ADD_USER_CREDIT_CARDS, this.newCardData);
        this.cancel();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_NEW_CARD_FORM_VISIBILITY, false);
    }
}
